export const workforcePartners = [
    { id: 0, name: 'AFT', image: require('~/assets/images/logos/indian_partner_logos/logo-aft.png') },
    { id: 1, name: 'Apollo', image: require('~/assets/images/logos/indian_partner_logos/logo-apollo.png') },
    { id: 2, name: 'Baton', image: require('~/assets/images/logos/indian_partner_logos/logo-baton.png') },
    { id: 3, name: 'wabi', image: require('~/assets/images/logos/indian_partner_logos/logo-wabi.png') },
    {
        id: 4,
        name: 'Csepel metál',
        image: require('~/assets/images/logos/indian_partner_logos/logo-csepel-metal.png'),
    },
    {
        id: 5,
        name: 'Duvenbeck',
        image: require('~/assets/images/logos/indian_partner_logos/logo-duvenbeck.png'),
    },
    {
        id: 6,
        name: 'Flextronix',
        image: require('~/assets/images/logos/indian_partner_logos/logo-flextronix.png'),
    },
    {
        id: 7,
        name: 'Magyarnet',
        image: require('~/assets/images/logos/indian_partner_logos/logo-magyarnet.png'),
    },
    { id: 8, name: 'Suzuki', image: require('~/assets/images/logos/indian_partner_logos/logo-suzuki.png') },
    {
        id: 9,
        name: 'Waberers',
        image: require('~/assets/images/logos/indian_partner_logos/logo-waberers.png'),
    },
];
